module.exports = __webpack_public_path__ + "static/media/YM01_3.292445ff.jpg";